module.exports = __webpack_public_path__ + "img/icon_left_msg_wh.05e9210d.svg";